import React from 'react';
import LegalLayout, { Section } from './LegalLayout';

/**
 * Nutzungsbedingungen für das interne Agentur-Tool (AgencyOS / TGOSM).
 */
export default function NutzungsbedingungenPage() {
    return (
        <LegalLayout title="Nutzungsbedingungen" updated="August 2026">
            <p>
                Diese Nutzungsbedingungen regeln die Verwendung der internen Arbeitsplattform „AgencyOS“
                (nachfolgend „die Plattform“), betrieben von der The Guardians of Social Media GmbH,
                Mahlerstraße 7/34, 1010 Wien, Österreich.
            </p>

            <Section heading="1. Geltungsbereich und Nutzerkreis">
                <p>
                    Die Plattform ist ein internes Werkzeug und ausschließlich zur Nutzung durch autorisierte
                    Mitarbeiterinnen und Mitarbeiter sowie beauftragte Talente („Social Faces“) des Betreibers
                    bestimmt. Ein Zugang wird ausschließlich durch den Betreiber vergeben. Eine öffentliche
                    Registrierung findet nicht statt.
                </p>
            </Section>

            <Section heading="2. Zugang und Zugangsdaten">
                <p>
                    Nutzer sind verpflichtet, ihre Zugangsdaten geheim zu halten und vor dem Zugriff Dritter zu
                    schützen. Die Anmeldung erfolgt per Benutzername/Passwort, optional über Google-Anmeldung
                    oder – bei Social Faces – über einen per E-Mail zugesandten Anmelde-Link. Ein Verdacht auf
                    Missbrauch ist unverzüglich dem Betreiber zu melden.
                </p>
            </Section>

            <Section heading="3. Zulässige Nutzung">
                <p>
                    Die Plattform darf ausschließlich zu dienstlichen Zwecken im Rahmen des jeweiligen
                    Beschäftigungs- oder Auftragsverhältnisses genutzt werden. Untersagt sind insbesondere die
                    unbefugte Weitergabe von Inhalten, das Auslesen fremder Daten sowie jede Nutzung, die gegen
                    geltendes Recht oder interne Richtlinien verstößt.
                </p>
            </Section>

            <Section heading="4. Inhalte und Daten">
                <p>
                    In der Plattform erfasste Inhalte (z. B. Aufgaben, Projekte, Kunden- und Abrechnungsdaten,
                    hochgeladene Dateien) verbleiben im Eigentum bzw. Verantwortungsbereich des Betreibers.
                    Nutzer sind für die Richtigkeit der von ihnen eingegebenen Daten verantwortlich.
                </p>
            </Section>

            <Section heading="5. Verfügbarkeit">
                <p>
                    Der Betreiber bemüht sich um einen möglichst störungsfreien Betrieb, übernimmt jedoch keine
                    Gewähr für eine ununterbrochene Verfügbarkeit. Wartungsarbeiten, technische Störungen oder
                    Anpassungen können den Zugang vorübergehend einschränken.
                </p>
            </Section>

            <Section heading="6. Beendigung">
                <p>
                    Mit Ende des Beschäftigungs- oder Auftragsverhältnisses erlischt die Nutzungsberechtigung.
                    Der Betreiber kann Zugänge jederzeit sperren oder löschen, insbesondere bei Verstoß gegen
                    diese Bedingungen.
                </p>
            </Section>

            <Section heading="7. Datenschutz">
                <p>
                    Informationen zur Verarbeitung personenbezogener Daten finden Sie in der{' '}
                    <a href="/datenschutz" className="text-primary hover:opacity-80">Datenschutzerklärung</a>.
                </p>
            </Section>

            <Section heading="8. Kontakt">
                <p>
                    Bei Fragen zur Nutzung wenden Sie sich an: office@theguardians.at
                </p>
            </Section>
        </LegalLayout>
    );
}
